type ContentLoadedCallbackFunction = (event: Event) => void

const callbackQueue: ContentLoadedCallbackFunction[] = []
let isDomContentLoaded = false
let domConentLoadedEvent: Event

window.addEventListener('DOMContentLoaded', event => {
  isDomContentLoaded = true
  domConentLoadedEvent = event
  callbackQueue.forEach(callback => callback(event))
})

function triggerOnContentLoaded(callback: ContentLoadedCallbackFunction): void {
  if (isDomContentLoaded) {
    callback(domConentLoadedEvent)
  } else {
    callbackQueue.push(callback)
  }
}

function isContentLoaded(): boolean {
  return isDomContentLoaded
}

export { triggerOnContentLoaded, isContentLoaded }
